export interface CallInitiationParams {
    bid_id?: number;
    load_id?: number;
    lorry_id?: number;
    ticket_id?: number;
    caller_id?: number;
    callee_id?: number;
    reference_id?: number;
    reference_type?: number;
}

export const hasSingleCallCalleeId = (params?: CallInitiationParams) => Boolean(params?.callee_id);

export const withSingleCallParams = (
    params: CallInitiationParams,
    single: Pick<CallInitiationParams, "caller_id" | "callee_id" | "reference_id" | "reference_type">
): CallInitiationParams => ({
    ...params,
    ...single
});
